var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"ktcsChatbotContents","data-domain":"__d2870012371","data-channel":"WEBCHAT","data-user":"sbizcenter","data-context":"https://qs.hiqri.ai","data-interface":"wss://qsif.hiqri.ai/sbizcenter/nlu/chat","data-imagepath":"https://qs.hiqri.ai"}})])
}]

export { render, staticRenderFns }